/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value3: "",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    index: "1",
    title: "Sản lượng dầu khí dự kiến khai thác trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value3: "thùng",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    index: "",
    title: "- Tính theo thùng",
  },
  {
    id: uuidV4(),
    value3: "m3",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    index: "",
    title: "- Tính theo m3",
  },
  {
    id: uuidV4(),
    value3: "ngày",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    index: "2",
    title: "Tổng số ngày khai thác dầu khí trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value3: "",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    index: "3",
    title: "Sản lượng khai thác bình quân ngày",
  },
  {
    id: uuidV4(),
    value3: "thùng/ngày",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    index: "",
    title: "- Tính theo thùng/ngày",
  },
  {
    id: uuidV4(),
    value3: "m3/ngày",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    index: "",
    title: "- Tính theo m3/ngày",
  },
  {
    id: uuidV4(),
    value3: "%",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    index: "4",
    title: "Tỷ lệ thuế tài nguyên tạm nộp",
  },
  {
    id: uuidV4(),
    value3: "%",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    index: "5",
    title: "Tỷ lệ thuế xuât khẩu tạm nộp",
  },
  {
    id: uuidV4(),
    value3: "%",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    index: "6",
    title: "Tỷ lệ thuế thu nhập doanh nghiệp tạm nộp đối với trường hợp bán trong nước",
  },
  {
    id: uuidV4(),
    value3: "%",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    index: "7",
    title: "Tỷ lệ thuế thu nhập doanh nghiệp tạm nộp đối với trường hợp xuất khẩu",
  },
  {
    id: uuidV4(),
    value3: "%",
    value4: "",
    value5: "",
    value6: "",
    value7: "",
    index: "8",
    title: "Tỷ lệ lãi nước chủ nhà nộp NSNN",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const isDisabled = (index) => [1, 5, 6, 7].includes(index) || !index;

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Nội dung
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Đơn vị tính
              </Td>
              <Td rowSpan={1} colSpan={4} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Sản phẩm
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", background: "#d7d7d7" }}>Dầu thô</Td>
              <Td style={{ textAlign: "center", background: "#d7d7d7" }}>Condensate</Td>
              <Td style={{ textAlign: "center", background: "#d7d7d7" }}>Khí thiên nhiên</Td>
              <Td style={{ textAlign: "center", background: "#d7d7d7" }}>Ghi chú</Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (5)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (6)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (7)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(index + 1) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.index}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: isDisabled(index + 1) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(index + 1) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value3}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(index + 1) ? "#ddeff3" : "transparent",
                  }}
                >
                  {isDisabled(index + 1) ? (
                    item.value4
                  ) : (
                    <InputTable
                      type="text"
                      id={item.id}
                      name="value4"
                      value={item.value4}
                      onChange={handleChange}
                    />
                  )}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(index + 1) ? "#ddeff3" : "transparent",
                  }}
                >
                  {isDisabled(index + 1) ? (
                    item.value5
                  ) : (
                    <InputTable
                      type="text"
                      id={item.id}
                      name="value5"
                      value={item.value5}
                      onChange={handleChange}
                    />
                  )}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(index + 1) ? "#ddeff3" : "transparent",
                  }}
                >
                  {isDisabled(index + 1) ? (
                    item.value6
                  ) : (
                    <InputTable
                      type="text"
                      id={item.id}
                      name="value6"
                      value={item.value6}
                      onChange={handleChange}
                    />
                  )}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: [1, 5].includes(index + 1) ? "#ddeff3" : "transparent",
                  }}
                >
                  {[1, 5].includes(index + 1) ? (
                    item.value7
                  ) : (
                    <InputTable
                      type="text"
                      id={item.id}
                      name="value7"
                      value={item.value7}
                      onChange={handleChange}
                    />
                  )}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, type, id, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type) {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, id });
    } else {
      onChange({ value, name, id });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: !type ? "right" : "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
